<template>
	<e-select
		v-model="seasonSelected"
		id="seasons"
		track-by="name"
		label="name"
		class="primary"
		:options="seasons"
		:searchable="true"
		:show-labels="false"
		:allow-empty="false"
		sort-desc
		:multiple="multiple"
		:max="max"
	>
		<template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
		<template slot="noOptions">{{ $t('global.list_empty') }}</template>
		<template slot="maxElements">{{ $t('select.max_elements', { max: max }) }}</template>
		<!-- s'il y a une valeur max ça ne sert à rien de tout sélectionner -->
		<template v-if="max > 0" slot="beforeList"><span class="d-none"></span></template>
	</e-select>
</template>

<script>
import Gynecologie from '@/mixins/Gynecologie'

export default {
	name: 'SeasonInput',
	mixins: [Gynecologie],
	props: {
		value: [Object, Array],
		selectPreviousDefault: {
			type: Boolean,
			default: () => {
				return false
			}
		},
		multiple: {
			type: Boolean,
			default: () => {
				return false
			}
		},
		onlyLast: {
			type: Boolean,
			default: () => {
				return false
			}
		},
		// Nombre maximum de saisons sélectionnables, 0 pour ne pas limiter
		max: {
			type: Number,
			default: () => {
				return 0
			}
		}
	},
	data () {
		return {
			seasons: [],
		}
	},
	created() {
		this.init_component()
	},
	methods: {
		async init_component() {
			const seasons = await this.loadSeasons(false, true)
			if(seasons) {
				for(let i = 0; i < seasons.length; i++) {
					this.seasons.push({
						name: seasons[i].season_label, 
						id: seasons[i].season_id,
						begin: seasons[i].season_start,
						end: seasons[i].season_end,
						season_id: seasons[i].season_id,
					})
					if(seasons[i].season_default) {
						if(this.selectPreviousDefault && i > 0) {
							this.seasonSelected = {
								name: seasons[i-1].season_label, 
								id: seasons[i-1].season_id,
								begin: seasons[i-1].season_start,
								end: seasons[i-1].season_end,
								season_id: seasons[i-1].season_id,
							}
						}
						else {
							this.seasonSelected = {
								name: seasons[i].season_label, 
								id: seasons[i].season_id,
								begin: seasons[i].season_start,
								end: seasons[i].season_end,
								season_id: seasons[i].season_id,
							}
						}
					}
				}
			}
			// Les saisons sont triées par date de début : on présélectionne les 5 plus récentes, sans dépasser le plafond
			if(this.multiple && !this.onlyLast) {
				const nb_preselection = this.max > 0 ? Math.min(5, this.max) : 5
				this.seasonSelected = this.seasons.slice(-nb_preselection)
			}
		}
	},
	computed: {
		seasonSelected: {
			get() {
				return this.value
			},
			set(val) {
				// e-select bloque déjà la sélection au delà du plafond, on se protège d'une valeur posée autrement
				if(this.max > 0 && Array.isArray(val) && val.length > this.max) {
					val = val.slice(0, this.max)
				}

				this.$emit('input', val)
				this.$emit('change', val)
			}
		}
	}
}
</script>
